<template lang="pug" src="./payment-log.pug"></template>
<style lang="scss" src="./payment-log.scss" scoped></style>

<script>
import { mapState } from 'vuex'
import copyToClipboard from '@/utils/copy'

export default {
    data: () => ({
        sorting: {}
    }),
    computed: {
        ...mapState({
            paymentLogs: state => state.paymentLogs.paymentLogs,
            isTableLoad: state => state.paymentLogs.isLoaded
        }),
        headers: function() {
            return [
                'request', 'response', 'type', 'createdAt', 'updatedAt'
            ].map(it => ({
                text: this.$vuetify.lang.t(`$vuetify.pages.PaymentLogs.table.${it}`),
                value: `"${it}"`
            }))
        }
    },
    created: function() {
        this.$store.dispatch('paymentLogs/getPaymentLogs', {
            paymentId: this.$route.params.id,
            column: this.sorting.sortBy,
            direction: this.sorting.descending ? 'desc' : 'asc'
        })
    },
    beforeDestroy: function() {
        this.$store.commit('paymentLogs/RESET_PAYMENT_LOGS')
    },
    methods: {
        copy(text) {
            if (text) {
                copyToClipboard(text)
            }
        }
    }
}
</script>
